var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useLoaderData, useLocation, useSearchParams } from 'react-router';

import { FunnelIcon } from '@heroicons/react/24/outline';
import { useAtomValue } from 'jotai';
import { Translate } from "../../../../I18N";

import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button, PaginationState, Paginator, Pill, Table } from "../../../Components/UI";
import { useIsFirstRender } from "../../../CustomHooks/useIsFirstRender";
import { settingsAtom } from "../../../atoms";

import { getActivityLogColumns } from "./components/TableElements";
import { ActivityLogSidePanel } from "./components/ActivityLogSidePanel";
import { FiltersSidePanel } from "./components/FiltersSidePanel";

import {
  getAppliedFilters,
  updateSearch,

  ITEMS_PER_PAGE,
  buildPageURL } from "./ActivityLogLoader";


const funnelColor = (appliedFiltersCount) =>
appliedFiltersCount > 0 ? 'rgb(30 64 175)' : 'rgb(115 115 115)rgb(115 115 115)';

// eslint-disable-next-line max-statements
const ActivityLog = () => {
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const { dateFormat = 'YYYY-MM-DD' } = useAtomValue(settingsAtom);
  const [sorting, setSorting] = useState([]);
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const isFirstRender = useIsFirstRender();
  const appliedFilters = getAppliedFilters(searchParams);

  const appliedFiltersCount = Object.keys(appliedFilters).filter((key) =>
  ['method', 'username', 'search', 'dateRange'].includes(key)
  ).length;

  const { activityLogData, totalPages, total, error } = useLoaderData();

  useEffect(() => {
    const [currentSorting] = sorting || [];
    const { id: sortingProp, desc } = currentSorting || {};
    const sortingOrder = desc ? 'desc' : 'asc';
    if (
    isFirstRender && (
    !sortingProp ||
    sortingProp === appliedFilters.sort && sortingOrder === appliedFilters.order))
    {
      return;
    }
    updateSearch({ sort: sortingProp, order: sortingOrder }, searchParams, setSearchParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sorting]);

  const onSubmit = async (data) => {
    updateSearch(data, searchParams, setSearchParams);
    setShowFilters(false);
  };

  const columns = getActivityLogColumns(setSelectedEntry, dateFormat);

  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', height: '100%', overflowY: 'auto' },
      "data-testid": "settings-activity-log" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Activity Log" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, { className: "space-y-3" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex justify-end" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      styling: "light",
      size: "small",
      className: "flex flex-row gap-4 items-center mr-0 align-middle",
      onClick: () => setShowFilters(true) }, void 0, /*#__PURE__*/

    _jsx(FunnelIcon, {
      stroke: funnelColor(appliedFiltersCount),
      fill: funnelColor(appliedFiltersCount),
      className: "w-5" }
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Filters"),
    appliedFiltersCount > 0 && /*#__PURE__*/_jsx(Pill, { color: "primary" }, void 0, appliedFiltersCount)
    )
    ),
    error === undefined && /*#__PURE__*/
    _jsx(Table, {
      data: activityLogData,
      columns: columns,
      defaultSorting: sorting,
      sortingFn: (sortingState) => {
        setSorting(sortingState);
      },
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Activity Log"

      ),

      footer: /*#__PURE__*/
      _jsx("div", { className: "flex justify-between h-6" }, void 0, /*#__PURE__*/
      _jsx(PaginationState, {
        page: Number(appliedFilters.page || 1),
        size: appliedFilters.limit || ITEMS_PER_PAGE,
        total: total,
        currentLength: activityLogData.length }
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Paginator, {
        totalPages: totalPages,
        currentPage: Number(appliedFilters.page || 1),
        buildUrl: (pageTo) =>
        buildPageURL(appliedFilters, pageTo, location) }

      )
      )
      ) }

    )

    )
    ), /*#__PURE__*/
    _jsx(ActivityLogSidePanel, {
      selectedEntry: selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.original,
      isOpen: selectedEntry !== null,
      onClose: () => {
        setSelectedEntry(null);
      } }
    ), /*#__PURE__*/
    _jsx(FiltersSidePanel, {
      isOpen: showFilters,
      onClose: () => setShowFilters(false),
      onSubmit: onSubmit,
      appliedFilters: appliedFilters }
    )
    ));

};

export { ActivityLog };